import React from "react";

function CreateAccountCta({ onDismiss }) {
  const registrationPath = window.UW211?.APP_PATHS?.registration || "/users/sign_up";

  return (
    <div className="resource-list-tip-pop-over open">
      <h4 className="share-title sub-headliner">Tip: Create an Account</h4>
      <div className="share-content">
        When you sign up for a 211 account, you can save a resource to a list and return to it later.
        <a className="add-resource-to-list btn create-now btn-primary" href={registrationPath}>
          Create an Account
        </a>
        <div className="skip-link">
          <a className="skip" href="#" onClick={(e) => { e.preventDefault(); onDismiss(); }}>
            Skip
          </a>
        </div>
      </div>
    </div>
  );
}

export default CreateAccountCta;
